import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'smt-session-model',
  templateUrl: './smt-session-model.component.html',
  styleUrls: ['./smt-session-model.component.scss']
})
export class SmtSessionModelComponent {
  @Input() isActive: boolean;
	@Input() disableHeader: boolean = false;
	@Input() disableFooter: boolean = false;
	@Input() acceptText: string;
	@Input() rejectText: string;

	@Output() acceptEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() rejectEvent: EventEmitter<any> = new EventEmitter<any>();

	onAccept(): boolean {
		this.acceptEvent.emit('accept');
		return false;
	}

	onReject(): boolean {
		this.rejectEvent.emit('reject');
		return false;
	}
}
